import { render } from "./DashboardOld.vue?vue&type=template&id=5323f42e"
import script from "./DashboardOld.vue?vue&type=script&lang=js"
export * from "./DashboardOld.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__